import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CalculateIcon from '@mui/icons-material/Calculate';
import SellIcon from '@mui/icons-material/Sell';
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { fetchValueModel, addImpactArea, editImpactAnalysis, fetchDriverAnalysis, fetchCostValueDriver } from "../../actions/valueActions";
import ValueModel from "./ValueModel";
import LoadingText from "../helpers/LoadingText";
import ImpactAnalysisDisplay from "./ImpactAnalysisDisplay";
import DriverAnalysisDisplay from "./DriverAnalysisDisplay";
import history from "../../history";

const ValueModelJourney = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    // Access state for valueModel and filter using searchParams
    const id = searchParams.get('id')
    const valueModel = useSelector(state => state.value.valueModel[id])
    const costStructure = useSelector(state => state.value.costStructure)

    useEffect(() => {
        dispatch(fetchCostValueDriver(id))
        dispatch(fetchValueModel(id))
        // eslint-disable-next-line react-hooks/exhaustive-deps        
    }, [])

    const onSubmitAddImpactArea = (values) => {
        const formValues = { 'wish': values }
        dispatch(addImpactArea(id, formValues))
    }

    const onSubmitEditImpactAnalysis = async (values) => {
        await dispatch(editImpactAnalysis(id, values))
        dispatch(fetchDriverAnalysis(id))
    }

    const renderHeader = (valueModel) => {
        return (
            <React.Fragment>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <Stack direction="row" alignItems="center" gap={1} sx={{ ml: 5, mt: 3 }}>
                        <CalculateIcon />
                        <Typography variant='h6'>
                            Value Models
                        </Typography>
                    </Stack>
                    <Button variant="contained" startIcon={<ArrowBackIosIcon />} onClick={() => history.push(`/value-models?id=${valueModel?.product.id}`)} sx={{ mr: '30%', mt: 3, textTransform: 'none' }}>
                        Back
                    </Button>
                </Stack>
                <Box>
                    <Stack direction="row" alignItems="center" gap={1} sx={{ ml: 5, mt: 3, display: 'inline-flex', border: '1px solid #ccc', borderRadius: '8px', padding: 2, }}>
                        <SellIcon sx={{ fontSize: '1rem' }} />
                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                            Product:
                        </Typography>
                        <Typography variant="body2">
                            {valueModel?.product.name}
                        </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" gap={1} sx={{ ml: 5, mt: 3, display: 'inline-flex', border: '1px solid #ccc', borderRadius: '8px', padding: 2, }}>
                        <CalculateIcon sx={{ fontSize: '1rem' }} />
                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                            Value Model:
                        </Typography>
                        <Typography variant="body2">
                            {valueModel?.name}
                        </Typography>
                    </Stack>
                </Box>
            </React.Fragment>
        )
    }

    if (valueModel && valueModel.step === 'created') {
        return (
            <Box>
                {renderHeader(valueModel)}
                <Box sx={{ mt: 20, ml: 15 }}>
                    <LoadingText
                        text="Analyzing outcome of product"
                    />
                </Box>
            </Box>
        )
    }
    else if (valueModel && valueModel.step === 'impact') {
        return (
            <Box>
                {renderHeader(valueModel)}
                <Box sx={{ mt: 5 }}>
                    <ImpactAnalysisDisplay
                        impactData={valueModel.impact_analysis}
                        onSubmitChecked={onSubmitEditImpactAnalysis}
                        onSubmitInput={onSubmitAddImpactArea}
                    />
                </Box>
            </Box>
        )
    }
    else if (valueModel && valueModel.step === 'driver_start') {
        return (
            <Box>
                {renderHeader(valueModel)}
                <Box sx={{ mt: 20, ml: 15 }}>
                    <LoadingText
                        text="Analyzing value drivers"
                    />
                </Box>
            </Box>
        )
    }
    else if (valueModel && Object.keys(costStructure).length > 0 && valueModel.driver_analysis && valueModel.step === 'driver_analysis') {
        return (
            <Box>
                {renderHeader(valueModel)}
                <DriverAnalysisDisplay
                    id={id}
                    valueModel={valueModel}
                    costStructure={costStructure}
                    driver_analysis={valueModel.driver_analysis}
                />
            </Box>
        )
    }
    else if (valueModel && valueModel.step === 'completed') {
        return (
            <ValueModel />
        )
    }
    else {
        return null
    }

    // return (
    //     <ValueModel />
    // )
}

export default ValueModelJourney